import GooglePlay from '@/assets/icons/google-pl.svg?react'

import { Button } from '@/ui-kit'
import clsx from 'clsx'
import { Link } from 'react-router-dom'
import rrStyles from './RestrictedDataBanner.module.css'

export const MobileAppBanner = () => {
  return (
    <Link
      className={clsx(rrStyles.gradient)}
      to="https://play.google.com/store/apps/details?id=acl.datahive.app"
      target="_blank"
      rel="noreferrer"
    >
      <div className={clsx(rrStyles.container, 'flex flex-col')}>
        <div className="relative -mx-3 -mt-[54px] h-[150px] overflow-hidden border-b border-solid border-gray-100 px-3">
          <img
            className={clsx('absolute bottom-0 left-1/2 h-auto h-full -translate-x-1/2 object-cover')}
            src="/images/hand.png"
            alt=""
          />
        </div>
        <p className={clsx(rrStyles.title, 'flex flex-col')}>
          <span>Collect data.</span>
          <span className="text-[--color]">Earn rewards.</span>
        </p>
        <p className={clsx(rrStyles.description, 'mt-1 mb-2')}>Download the app today on Google Play.</p>
        <Button variant="secondary">
          <GooglePlay />
        </Button>
      </div>
    </Link>
  )
}
